/*@flow*/
import type { Node } from 'react';
import React from 'react';
import type { LocalsT } from '../types';
import cx from 'classnames';

const Component = (props: {
  className?: string,
  children: React$Node,
  hasError?: boolean,
}) => {
  const className = {
    'form-group': true,
    'has-error': props.hasError,
  };
  if (props.className) {
    className[props.className] = true;
  }
  return <div className={cx(className)}>{props.children}</div>;
};

type PropsT = { children: React$Node } & LocalsT;

export default (props: PropsT): Node => {
  const { children, ...locals } = props || {};
  const { path, hasError } = locals;

  let className = `form-group-depth-${path.length}`;
  if (path.length > 0) {
    className += ` form-group-${path.join('-')}`;
  }

  return (
    <Component className={className} hasError={hasError}>
      {children}
    </Component>
  );
};
